import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=2b02d0c4&"
import script from "./Step4.vue?vue&type=script&lang=ts&"
export * from "./Step4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports